
import { Button } from "@/components/ui/button";
import { Edit, Trash2, UserPlus } from "lucide-react";
import { ClientTableActionsProps } from "../utils/client-table-utils";

const ClientTableActions = ({ 
  client, 
  onEdit, 
  onDelete, 
  onCreateAccount,
  isCreatingAccount,
  showActions = true 
}: ClientTableActionsProps) => {
  if (!showActions) return null;
  
  return (
    <div className="flex justify-end gap-2">
      {client.email && !client.auth_user_id && onCreateAccount && (
        <Button 
          variant="outline" 
          size="icon" 
          onClick={() => onCreateAccount(client)} 
          disabled={isCreatingAccount === client.id} 
          title="Crea account utente"
        >
          <UserPlus className="h-4 w-4" />
        </Button>
      )}
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={() => onEdit(client)} 
        title="Modifica cliente"
      >
        <Edit className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={() => onDelete(client)} 
        title="Elimina cliente"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ClientTableActions;

